import {
  IFileResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IFileResponseInstance'
import {FileThumbnailType} from '@toolify/client/src/modules/files/enum/FileThumbnailType'
import {StaticFileVariantKey} from '@toolify/server/src/services/FileVariantService/enum/StaticFileVariantKey'
import {ICommonFileThumbnailData} from '@toolify/client/src/modules/files/types/ICommonFileThumbnailData'
import {FileThumbnailDisplayType} from '@toolify/client/src/modules/files/enum/FileThumbnailDisplayType'
import {UniqueFileIconMap} from '@toolify/client/src/modules/files/maps/UniqueFileIconMap'
import {CommonFileType} from '@toolify/server/src/services/FileTypeService/enum/CommonFileType'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'

export const FileThumbnailDisplayTypeToCommonThumbnailDataMap = new Map<FileThumbnailDisplayType,(file?: IFileResponseInstance) => ICommonFileThumbnailData>([
  [FileThumbnailDisplayType.Image, (file: IFileResponseInstance) => {
    // if(!imageUrl) {
    //   return {
    //     thumbnailType: FileThumbnailType.Default,
    //     thumbnailPayload: {
    //       iconNameType: UniqueFileIconMap.get(CommonFileType.Image).iconNameType,
    //     },
    //     iconNameType: UniqueFileIconMap.get(CommonFileType.Image).iconNameType,
    //     iconColor: UniqueFileIconMap.get(CommonFileType.Image).color,
    //   }
    // }
    return {
      thumbnailType: FileThumbnailType.Image,
      thumbnailPayload: {
        fileVariants: file.variants,
        iconNameType: UniqueFileIconMap.get(CommonFileType.Image).iconNameType,
      },
      iconNameType: UniqueFileIconMap.get(CommonFileType.Image).iconNameType,
      iconColor: UniqueFileIconMap.get(CommonFileType.Image).color,
    }
  }],
  [FileThumbnailDisplayType.Audio, (file: IFileResponseInstance) => {
    const audioWaveformFileVariant = file.variants.find((variant) => variant.key === StaticFileVariantKey.AudioWaveform)
    if(audioWaveformFileVariant) {
      return {
        thumbnailType: FileThumbnailType.Audio,
        thumbnailPayload: {
          url: file.url,
          waveformUrl: audioWaveformFileVariant.url,
          mimeType: file.mimeType,
        },
        iconNameType: UniqueFileIconMap.get(CommonFileType.Audio).iconNameType,
        iconColor: UniqueFileIconMap.get(CommonFileType.Audio).color,
      }
    }
    return {
      thumbnailType: FileThumbnailType.Default,
      thumbnailPayload: {
        iconNameType: UniqueFileIconMap.get(CommonFileType.Audio).iconNameType,
      },
      iconNameType: UniqueFileIconMap.get(CommonFileType.Audio).iconNameType,
      iconColor: UniqueFileIconMap.get(CommonFileType.Audio).color,
    }
  }],
  [FileThumbnailDisplayType.Document, (file: IFileResponseInstance) => {
    return {
      thumbnailType: FileThumbnailType.Image,
      thumbnailPayload: {
        fileVariants: file.variants,
        iconNameType: UniqueFileIconMap.get(CommonFileType.Document).iconNameType,
      },
      iconNameType: UniqueFileIconMap.get(CommonFileType.Document).iconNameType,
      iconColor: UniqueFileIconMap.get(CommonFileType.Document).color,
    }
  }],
  [FileThumbnailDisplayType.Video, (file: IFileResponseInstance) => {
    const imageUrl = file.variants.find((variant) => variant.type === 'image')?.url
    if(!imageUrl) {
      return {
        thumbnailType: FileThumbnailType.Default,
        thumbnailPayload: {
          iconNameType: UniqueFileIconMap.get(CommonFileType.Video).iconNameType,
        },
        iconNameType: UniqueFileIconMap.get(CommonFileType.Video).iconNameType,
        iconColor: UniqueFileIconMap.get(CommonFileType.Video).color,
      }
    }
    return {
      thumbnailType: FileThumbnailType.Image,
      thumbnailPayload: {
        fileVariants: file.variants,
        iconNameType: UniqueFileIconMap.get(CommonFileType.Document).iconNameType,
      },
      iconNameType: UniqueFileIconMap.get(CommonFileType.Video).iconNameType,
      iconColor: UniqueFileIconMap.get(CommonFileType.Video).color,
    }
  }],
  [FileThumbnailDisplayType.Unknown, () => {
    return {
      thumbnailType: FileThumbnailType.Default,
      thumbnailPayload: {
        iconNameType: UniqueFileIconMap.get(CommonFileType.Other).iconNameType,
      },
      iconNameType: UniqueFileIconMap.get(CommonFileType.Other).iconNameType,
      iconColor: UniqueFileIconMap.get(CommonFileType.Other).color,
    }
  }],
  [FileThumbnailDisplayType.Sheet, (file: IFileResponseInstance) => {
    return {
      thumbnailType: FileThumbnailType.Image,
      thumbnailPayload: {
        fileVariants: file.variants,
        iconNameType: UniqueFileIconMap.get(CommonFileType.Sheet).iconNameType,
      },
      iconNameType: UniqueFileIconMap.get(CommonFileType.Sheet).iconNameType,
      iconColor: UniqueFileIconMap.get(CommonFileType.Sheet).color,
    }
  }],
  [FileThumbnailDisplayType.Markdown, () => {
    return {
      thumbnailType: FileThumbnailType.Default,
      thumbnailPayload: {
        iconNameType: UniqueFileIconMap.get(CommonFileType.Markdown).iconNameType,
        iconColor: UniqueFileIconMap.get(CommonFileType.Markdown).color,
      },
      iconNameType: UniqueFileIconMap.get(CommonFileType.Markdown).iconNameType,
      iconColor: UniqueFileIconMap.get(CommonFileType.Markdown).color,
    }
  }],
  [FileThumbnailDisplayType.Text, () => {
    return {
      thumbnailType: FileThumbnailType.Default,
      thumbnailPayload: {
        iconNameType: UniqueFileIconMap.get(CommonFileType.Text).iconNameType,
        iconColor: UniqueFileIconMap.get(CommonFileType.Text).color,
      },
      iconNameType: UniqueFileIconMap.get(CommonFileType.Text).iconNameType,
      iconColor: UniqueFileIconMap.get(CommonFileType.Text).color,
    }
  }],
  [FileThumbnailDisplayType.Archive, () => {
    return {
      thumbnailType: FileThumbnailType.Default,
      thumbnailPayload: {
        iconNameType: UniqueFileIconMap.get(CommonFileType.Archive).iconNameType,
        iconColor: UniqueFileIconMap.get(CommonFileType.Archive).color,
      },
      iconNameType: UniqueFileIconMap.get(CommonFileType.Archive).iconNameType,
      iconColor: UniqueFileIconMap.get(CommonFileType.Archive).color,
    }
  }],
  [FileThumbnailDisplayType.Html, (file: IFileResponseInstance) => {
    // The rendered page only exists once the html has been through pdf and back out as an image, and
    // for a file uploaded before that chain existed it never will - so the icon stays the answer
    // whenever there is no image variant to show, the way the video entry handles a missing frame.
    const hasImageVariant = file?.variants?.some((variant) => variant.type === 'image')
    if(!hasImageVariant) {
      return {
        thumbnailType: FileThumbnailType.Default,
        thumbnailPayload: {
          iconNameType: UniqueFileIconMap.get(CommonFileType.Html).iconNameType,
          iconColor: UniqueFileIconMap.get(CommonFileType.Html).color,
        },
        iconNameType: UniqueFileIconMap.get(CommonFileType.Html).iconNameType,
        iconColor: UniqueFileIconMap.get(CommonFileType.Html).color,
      }
    }
    return {
      thumbnailType: FileThumbnailType.Image,
      thumbnailPayload: {
        fileVariants: file.variants,
        iconNameType: UniqueFileIconMap.get(CommonFileType.Html).iconNameType,
      },
      iconNameType: UniqueFileIconMap.get(CommonFileType.Html).iconNameType,
      iconColor: UniqueFileIconMap.get(CommonFileType.Html).color,
    }
  }],
  [FileThumbnailDisplayType.Folder, () => {
    return {
      thumbnailType: FileThumbnailType.Default,
      thumbnailPayload: {
        iconNameType: IconNameType.Folder,
      },
      iconNameType: IconNameType.Folder,
      iconColor: '#e88000',
    }
  }],
])
